import { jsx } from "react/jsx-runtime";
import { MortgageRatesTable } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const BlockMortgageRatesTable = ({
  attrs,
  blockData = {}
}) => {
  const {
    columns,
    loanToValueBucket = "Normal",
    creditScoreBucket = "VeryHigh",
    refinance = false,
    rateLocation = "US",
    rateCompare = "lastWeek"
  } = attrs;
  return /* @__PURE__ */ jsx(MortgageRatesTable, { loanToValueBucket, creditScoreBucket, refinance, rateLocation, partnerId: "RD-QCBWMVN", nextData: blockData, columns, rateCompare });
};
BlockMortgageRatesTable.getBlockData = async ({
  attrs,
  innerBlocks
}) => {
  const {
    loanToValueBucket = "Normal",
    creditScoreBucket = "VeryHigh",
    refinance = false,
    rateLocation = "US",
    rateCompare = "lastWeek"
  } = attrs;
  const data = await MortgageRatesTable.fetchMortgageRates({
    partnerId: "RD-QCBWMVN",
    queries: (innerBlocks == null ? void 0 : innerBlocks.map((block) => ({
      program: block.attrs.program || "Fixed30Year",
      loanType: block.attrs.loanType || "Conventional",
      loanSize: block.attrs.loanSize || "Conforming",
      link: block.attrs.link || null
    }))) || [],
    loanToValueBucket,
    creditScoreBucket,
    refinance,
    rateLocation,
    rateCompare
  });
  return {
    rates: data
  };
};
BlockMortgageRatesTable.propTypes = {
  attrs: PropTypes.shape({}),
  index: PropTypes.number
};
export {
  BlockMortgageRatesTable as default
};
